import React from 'react';
import PropTypes from 'prop-types';

import { createAsyncToken } from '@bingads-webui-universal/primitive-utilities';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { getDisplayName } from '@bingads-webui-react/hoc-utils';

export const withImgAutoRetrieve = (WrappedComponent) => {
  class HoC extends React.Component {
    static displayName = `withImgAutoRetrieve(${getDisplayName(WrappedComponent)})`;

    static propTypes = {
      odata: PropTypes.PropTypes.shape({
        get: PropTypes.func.isRequired,
      }).isRequired,
      cid: PropTypes.string.isRequired,
      aid: PropTypes.string.isRequired,
    };

    state = {
      allowCrawlImagesFromLandingPage: undefined,
    };

    componentDidMount = () => {
      this.reload();
    };

    componentWillUnmount = () => {
      this.cancel();
    };

    reload = () => {
      this.cancel();

      const {
        odata,
        cid,
        aid,
      } = this.props;

      const url = `Customers(${cid})/Accounts(${aid})?$select=AllowCrawlImagesFromLandingPage`;

      this.loadToken = createAsyncToken(odata.get(url))
        .on({
          onSuccess: (response) => {
            this.setState({
              allowCrawlImagesFromLandingPage: response.AllowCrawlImagesFromLandingPage,
            });
          },
        });
    };

    cancel = () => {
      if (this.loadToken) {
        this.loadToken.cancel();
      }
    };

    render = () => {
      if (this.state.allowCrawlImagesFromLandingPage === undefined) {
        return null;
      }

      return (<WrappedComponent
        {...this.props}
        allowCrawlImagesFromLandingPage={this.state.allowCrawlImagesFromLandingPage}
      />);
    };
  }

  return hoistNonReactStatics(HoC, WrappedComponent);
};
